<div class="content-card">
    <div class="map-container">
        <div class="map-frame">
            <div id="map">
                <div mat-dialog-actions align="end">
                    <div style="position: relative; z-index: 9999; padding: 5px;" fxLayout="column"
                        fxLayoutAlign="end end">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>